import AppClient from "../utils/http-client/app-client"
import { ApiResponse } from "../utils/type/api-response.type"
import {
  CsdRequestBody,
  CsdResponseBody,
  HomeRequestBody,
  HomeResponseBody,
} from "../utils/type/statement-service.type"

export const getCardSummaryByCustomer = (
  requestBody: CsdRequestBody
): ApiResponse<CsdResponseBody> => {
  return AppClient.post("/api/v1/statements/csd", {
    nationalId: requestBody.nationalId,
    dateOfBirth: requestBody.dateOfBirth,
  })
}

export const getCardsByStatementUuid = (
  requestBody: HomeRequestBody
): ApiResponse<HomeResponseBody> => {
  return AppClient.post(
    `/api/v1/statements/${requestBody.statementUuid}/cards`,
    {
      nationalId: requestBody.nationalId,
      dateOfBirth: requestBody.dateOfBirth,
    }
  )
}

export default getCardsByStatementUuid
